/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface SaveLicenseDataAccessModules$Request {
    licenseId: number;
    requestBody: Array<string>;
}

export interface SaveLicenseDataAccessModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLicenseDataAccessModulesRequest = createAction<PayloadData<void, SaveLicenseDataAccessModules$Request>>('SAVE_LICENSE_DATA_ACCESS_MODULES__SAVE_LICENSE_DATA_ACCESS_MODULES__REQUEST');
export const saveLicenseDataAccessModulesSuccess = createAction<PayloadData<void, SaveLicenseDataAccessModules$Request>>('SAVE_LICENSE_DATA_ACCESS_MODULES__SAVE_LICENSE_DATA_ACCESS_MODULES__SUCCESS');
export const saveLicenseDataAccessModulesFailure = createAction<PayloadData<Error, SaveLicenseDataAccessModules$Request, true>>('SAVE_LICENSE_DATA_ACCESS_MODULES__SAVE_LICENSE_DATA_ACCESS_MODULES__FAILURE');

export const saveLicenseDataAccessModulesActions = [
    saveLicenseDataAccessModulesRequest,
    saveLicenseDataAccessModulesSuccess,
    saveLicenseDataAccessModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLicenseDataAccessModules = (meta: SaveLicenseDataAccessModules$Request, config?: SaveLicenseDataAccessModules$Config) => {
    return {
        CALL_API: {
            types: saveLicenseDataAccessModulesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/licenses/${meta.licenseId}/data-access-module`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

